import React, { FC, useRef, useState, MouseEventHandler } from 'react';
import { Placement } from '@popperjs/core';
import classNames from 'classnames';
import { EditStrongIcon, AddStrongIcon, PreviewStrongIcon, DotMenuStrongIcon } from 'src/monet/icons';

import OrganizationLink from 'src/common/OrganizationLink';
import { IconButton } from 'src/common/icon-button';
import { DashboardHomeOrganizationTemplateOptions } from './options';
import { useCurrentOrganization } from 'src/store/organization';
import { generateJourneyShareUrl } from 'src/utils/journey';
import { TooltipComponent } from 'src/common/tooltip/component';
import { useNewJourneyStore } from 'src/dashboard/store/new-journey';
import useDashboardStore from 'src/dashboard/store/dashboard';

interface DashboardHomeOrganizationTemplateActionsProps {
  template: any;
  onDelete: () => void;
}

export const DashboardHomeOrganizationTemplateActions: FC<DashboardHomeOrganizationTemplateActionsProps> = ({
  template,
  onDelete,
}) => {
  const { currentOrganization, currentWorkspace, teamWorkspace } = useCurrentOrganization();
  const menuPlacementRef = useRef<Placement>();
  const [keepMenuOpen, setKeepMenuOpen] = useState(false);
  const setJourneyWorkspace = useNewJourneyStore((state) => state.setJourneyWorkspace);
  const setJourneyTemplate = useNewJourneyStore((state) => state.setJourneyTemplate);
  const setIsCreatingJourneyFromTemplate = useDashboardStore((state) => state.setIsCreatingJourneyFromTemplate);

  const onMenuOpen = (placement?: Placement) => {
    menuPlacementRef.current = placement;
    setKeepMenuOpen(true);
  };

  const onMenuClose = () => {
    setKeepMenuOpen(false);
  };

  const onCreateJourneyWithtemplateClick = () => {
    setJourneyWorkspace(currentWorkspace && currentWorkspace.id ? currentWorkspace : teamWorkspace);
    setJourneyTemplate(template);
    setIsCreatingJourneyFromTemplate(true);
  };

  const journeyEditUrl = template.journey.is_neue ? `/journeys/neue-edit/${template.journey.uuid}` : `/journeys/edit/${template.journey.uuid}`;

  return (
    <div
      className={classNames(
        'flex transition group-hover:opacity-100 grow-0 items-center space-x-sm',
        keepMenuOpen ? 'opacity-100' : 'opacity-0'
      )}
    >
      <TooltipComponent tooltipContent='Create Journey with Template' placement='top'>
        <div className='hover:opacity-80' onClick={onCreateJourneyWithtemplateClick}>
          <IconButton onClick={onCreateJourneyWithtemplateClick}>
            <AddStrongIcon />
          </IconButton>
        </div>
      </TooltipComponent>
      <a target='blank' rel='noopener noreferrer' href={generateJourneyShareUrl(currentOrganization, template.journey)}>
        <IconButton>
          <PreviewStrongIcon />
        </IconButton>
      </a>
      <OrganizationLink to={journeyEditUrl}>
        <IconButton>
          <EditStrongIcon />
        </IconButton>
      </OrganizationLink>
      <DashboardHomeOrganizationTemplateOptions
        onOpen={onMenuOpen}
        onClose={onMenuClose}
        onDelete={onDelete}
        nestedMenuPlacement={menuPlacementRef.current}
        renderMenuOrigin={(onClick: MouseEventHandler) => (
          <IconButton onClick={onClick}>
            <DotMenuStrongIcon />
          </IconButton>
        )}
      />
    </div>
  );
};
